module.exports = __webpack_public_path__ + "img/img_32419_0_21.396782bb.png";